import { useNotificationsSubscription } from './chunk-VGNWDLIO.mjs';
import { useFeatureFlagSubscription } from './chunk-OTOFLJUZ.mjs';
import { useAuthContext } from './chunk-K3UDKV2P.mjs';
import { __export } from './chunk-4U7ZT42S.mjs';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createContext, useContext, useEffect } from 'react';
import { jsx } from 'react/jsx-runtime';

// src/providers/query/index.tsx
var query_exports = {};
__export(query_exports, {
  QueryProvider: () => QueryProvider,
  useQueryContext: () => useQueryContext
});
var queryClient = new QueryClient();
var QueryContext = createContext(void 0);
var QueryContextProvider = (props) => {
  var _a;
  const { config, children } = props;
  const { hasuraUrl } = config;
  const featureFlags = useFeatureFlagSubscription(hasuraUrl);
  const notifications = useNotificationsSubscription(hasuraUrl);
  const { user } = useAuthContext();
  const userId = (_a = user == null ? void 0 : user.id) != null ? _a : null;
  useEffect(() => {
    queryClient.clear();
  }, [userId]);
  const contextValue = {
    hasuraUrl,
    featureFlags,
    notifications,
    invalidateQuery: (queryKey) => {
      queryClient.removeQueries({ queryKey, exact: true });
      queryClient.refetchQueries({
        queryKey,
        exact: true,
        type: "active"
      });
    }
  };
  return /* @__PURE__ */ jsx(QueryContext.Provider, { value: contextValue, children });
};
var QueryProvider = ({ config, children }) => {
  return /* @__PURE__ */ jsx(QueryClientProvider, { client: queryClient, children: /* @__PURE__ */ jsx(QueryContextProvider, { config, children }) });
};
var useQueryContext = () => {
  const context = useContext(QueryContext);
  if (!context) {
    throw new Error("useQueryContext must be used within an QueryProvider");
  }
  return context;
};

export { QueryProvider, query_exports, useQueryContext };
//# sourceMappingURL=chunk-YJXGQ4TA.mjs.map
//# sourceMappingURL=chunk-YJXGQ4TA.mjs.map